// FOR USE WITHIN JS / JSX CODE

export const COLORS = {
  primary: "#75ab4a",
  primaryLight: "#90c168",
  primaryDark: "#598f2d",
  secondary: "#f99122",
  secondaryLight: "#ffb362",
  secondaryDark: "#d87409",
};

export const SHADOWS = {
  shadowXSmall: "0 2px 3px rgba(0, 0, 0, 0.16), 0 2px 3px rgba(0, 0, 0, 0.23)",
  shadowSmall: "0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23)",
  shadowMedium:
    "0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23)",
  shadowLarge:
    "0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22)",
};
